import React from 'react';
import useSWR from 'swr';

const TransformationsCount = () => {
    const fetcher = (...args) =>
        fetch(...args)
            .then(res => res.json())
            .then(json => `${json.transformationsCount + 174144}`);

    const { data, error } = useSWR(
        'https://api.apimatic.io/admin/transformations/total-count',
        fetcher
    );

    return (
        <>
            <div className="relative flex justify-around w-full h-16 px-4 my-4 text-6xl text-white">
                {data &&
                    data.split('').map(digit => (
                        <div key={digit + Math.random()} className="w-12 text-center bg-concrete">
                            {digit}
                        </div>
                    ))}
                {(!data || error) && (
                    <>
                        <div className="w-12 text-center bg-concrete">0</div>
                        <div className="w-12 text-center bg-concrete">0</div>
                        <div className="w-12 text-center bg-concrete">0</div>
                        <div className="w-12 text-center bg-concrete">0</div>
                        <div className="w-12 text-center bg-concrete">0</div>
                        <div className="w-12 text-center bg-concrete">0</div>
                    </>
                )}
                <div className="absolute w-full h-1 mt-8 bg-concrete-dark" />
            </div>
            <div className="w-full px-8 text-xl text-white lg:text-2xl lg:px-5 text-center">
                <strong> APIs transformed </strong> and counting..
            </div>
        </>
    );
};

export default TransformationsCount;
